import { ScreenshotClocks } from '@shared';
import { API_ROUTES, request } from './instance';
import { AuditInProgressAPI } from './auditor.service';

// swagger https://qa-auditor.proctorfree.com/swagger-ui/#/api-audit-controller

export const getScreenshotClocks = (streamHandle: string | undefined) => {
  return streamHandle === undefined
    ? Promise.reject(new Error('Invalid streamHandle'))
    : request<ScreenshotClocksAPI>({
        url: `${API_ROUTES.apiV1AuditScreenshotClocks(streamHandle)}`,
        method: 'GET',
      });
};

export const getAuditAnomalies = (examSession?: string, auditUuid?: string) => {
  return auditUuid === undefined || examSession === undefined
    ? Promise.reject(new Error('Invalid streamHandle'))
    : request<AnomalyTypeAPI[]>({
        url: `${API_ROUTES.apiV1AuditAnomalies(examSession, auditUuid)}`,
        method: 'GET',
      });
};

export const restartAudit = (auditUuid: string) => {
  return request({
    url: `${API_ROUTES.apiV1AuditRestart(auditUuid)}`,
    method: 'POST',
  });
};

export const startAudit = (examSessionUuid: string) => {
  return request<Pick<AuditInProgressAPI, 'auditUuid'>>({
    url: `${API_ROUTES.apiV1AuditStart(examSessionUuid)}`,
    method: 'POST',
  });
};

type ScreenshotClocksAPI = {
  screenshotClocks: ScreenshotClocks | null;
};

type CommentTypeAPI = {
  comment: string;
  name: string;
  stamp: number[];
  userId: number;
};

type AnomalyTypeAPI = {
  uuid: string;
  id: number;
  start: number;
  end: number;
  label: string;
  description: string;
  anomalyTypeId: number;
  comments: CommentTypeAPI[];
};
